exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".adds-container {\r\n  width: 200px;\r\n  border: solid darkseagreen 1px;\r\n  min-height: 600px;\r\n  position: fixed;\r\n  top:205px;\r\n  right: 0;\r\n}\r\n.main-div{\r\n  padding-bottom:0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/container/container.component.css
// module id = ../../../../../src/app/container/container.component.css
// module chunks = main